module.exports = __webpack_public_path__ + "media/images/front/pc/institution-treatment-information/img_plan-883acd77b5e5ada33ac549f959a0c2a9.jpg";